import { makeStyles } from '@material-ui/core';

import constants from '../../../abstracts/constants';
import colors from '../../../abstracts/colours';

export const useStyles = makeStyles({
  root: {
    height: '56px',
    minWidth: '150px',
    padding: '13px 16px',
    borderRadius: '6px',
    fontSize: '18px',
  },
  sizeLarge: {
    height: '64px',
    minWidth: '176px',
    padding: '16px 32px',
    borderRadius: '10px',
    fontSize: '20px',
  },
  sizeSmall: {
    height: '40px',
    minWidth: '120px',
    padding: '5px 16px',
    fontSize: '16px',
  },
  label: {
    fontFamily: constants.sourceSansPro,
    fontSize: 'inherit',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'inherit',
    textTransform: 'initial',
  },
  outlinedPrimary: {
    border: `solid 2px ${colors.scienceBlue}`,
    color: colors.scienceBlue,
    '&:hover': {
      backgroundColor: colors.scienceBlue,
      border: `solid 2px ${colors.scienceBlue}`,
      color: colors.alabaster,
    },
    '&:focus': {
      border: `solid 2px ${colors.cobalt}`,
      color: colors.cobalt,
    },
    '&:active': {
      border: `solid 2px ${colors.cobalt}`,
      backgroundColor: colors.cobalt,
      color: colors.alabaster,
    },
    '&:disabled': {
      border: `solid 2px ${colors.gallery}`,
      backgroundColor: colors.white,
    },
  },
  containedPrimary: {
    backgroundColor: colors.scienceBlue,
    border: `solid 2px ${colors.scienceBlue}`,
    color: colors.alabaster,
    '&:hover': {
      backgroundColor: colors.bluish,
      border: `solid 2px ${colors.bluish}`,
      color: colors.alabaster,
    },
    '&:focus': {
      border: `solid 2px ${colors.cobalt}`,
      backgroundColor: colors.bluish,
      color: colors.alabaster,
    },
    '&:active': {
      border: `solid 2px ${colors.cobalt}`,
      backgroundColor: colors.cobalt,
      color: colors.alabaster,
    },
    '&:disabled': {
      backgroundColor: colors.gallery,
      border: `solid 2px ${colors.gallery}`,
    },
  },
  containedSecondary: {
    backgroundColor: colors.cherry,
    border: `solid 2px ${colors.cherry}`,
    '&:focus': {
      border: `solid 2px ${colors.cobalt}`,
      backgroundColor: colors.darkPink,
    },
  },
  textPrimary: {
    border: `solid 2px transparent`,
    backgroundColor: 'transparent',
    color: colors.abbey,
    '&:hover': {
      border: `solid 2px ${colors.alabaster}`,
      backgroundColor: colors.alabaster,
      color: colors.xanadu,
    },
    '&:focus': {
      border: `solid 2px ${colors.cobalt}`,
    },
    '&:active': {
      border: `solid 2px ${colors.bonJour}`,
      backgroundColor: colors.bonJour,
      color: colors.abbey,
    },
    '&:disabled': {
      border: `solid 2px ${colors.white}`,
      backgroundColor: colors.white,
    },
  },
  disabled: {
    color: colors.silver,
  },
});
